import { FadeInWrapper, Footer, LoadingIcon, Main, MainContent } from "@prosolve/common-components-ui";
import useIsMobileView from "../../hooks/useIsMobileView";
import OpportunityCards from "./OpportunityCards";
import RefreshShippingButton from "../Shared/RefreshShippingButton";
import { useState } from "react";

const SectionDivider = () => <div style={{ height: '20px' }}>&nbsp;</div>

export default function Dashboard ({ 
  shipModals 
}) {
  const isMobileView = useIsMobileView();

  const [isLoading, setIsLoading] = useState(false)

  const onRefreshStart = () => {
    setIsLoading(true)
  }

  const onRefreshComplete = () => {
    setIsLoading(false)
  }

  return (
    <Main $isMobileView={isMobileView} $backgroundColor={'inherit'} style={{ padding: '10px' }}>
      <MainContent $isMobileView={isMobileView} style={{ maxWidth: 'none', width: '90%' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ flexGrow: 1, fontSize: '28px', fontWeight: 'bold' }}>
            {'Dashboard'}
          </div>
          <div style={{ paddingRight: '50px', fontSize: '1rem' }}>
            <RefreshShippingButton onStart={onRefreshStart} onComplete={onRefreshComplete} />
          </div>
        </div>
        {isLoading 
          ? <div style={{ textAlign: 'center', margin: '100px 0' }}><LoadingIcon /></div>
          : <FadeInWrapper><OpportunityCards shipModals={shipModals} /></FadeInWrapper>
        }
        <SectionDivider />
        <Footer />
      </MainContent>
    </Main>
  )
}